import { User } from 'oidc-client-ts';

export const getOidcUser = (): User | null => {
  const authority = import.meta.env.VITE_JUMP_URL;
  const clientId = import.meta.env.VITE_CLIENT_ID;
  const oidcStorage = localStorage.getItem(`oidc.user:${authority}:${clientId}`);
  if (!oidcStorage) {
    return null;
  }
  return User.fromStorageString(oidcStorage);
};
